import React from 'react';
import { useIntl } from 'react-intl';
import { Paper, Tooltip, alpha } from '@mui/material';
import TrendingDownRoundedIcon from '@mui/icons-material/TrendingDownRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import { CenteredFlexBox } from '../FlexBox';

const RedemptionPaper = function RedemptionPaper({
  redemptionReached,
  disabled,
}) {
  const intl = useIntl();
  return (
    <Paper
      sx={{
        borderRadius: '50px',
        width: '48px',
        height: '48px',
        cursor: 'pointer',
        backgroundColor: (theme) =>
          alpha(
            disabled
              ? theme.palette.action.disabledBackground
              : redemptionReached
                ? theme.palette.success.main
                : theme.palette.error.main,
            0.3
          ),
        border: (theme) =>
          `2px solid ${disabled ? theme.palette.action.disabledBackground : redemptionReached ? theme.palette.success.main : theme.palette.error.main}`,
      }}
    >
      <CenteredFlexBox
        justifyContent="center"
        alignItems="center"
        height="100%"
        padding="12px"
      >
        <Tooltip
          arrow
          title={
            disabled
              ? undefined
              : intl.messages[
                  redemptionReached
                    ? 'AVERAGE_REDEMPTION_REACHED'
                    : 'AVERAGE_REDEMPTION_NOT_REACHED'
                ]
          }
          placement="bottom"
        >
          {redemptionReached ? (
            <TrendingUpRoundedIcon
              color={!disabled ? 'success' : 'disabled'}
              sx={{ fontSize: '24px' }}
            />
          ) : (
            <TrendingDownRoundedIcon
              color={!disabled ? 'error' : 'disabled'}
              sx={{ fontSize: '24px' }}
            />
          )}
        </Tooltip>
      </CenteredFlexBox>
    </Paper>
  );
};

export default RedemptionPaper;
